import React from 'react';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import { redirectToMaintenance } from 'Helpers/Redirect';
import { Authentication } from 'Views/Authentication';

export const LoginExperimental = () => {
  const { homeResource } = useHomeContext();

  const loginRelationship = homeResource.withRelationship(fr.relationships.loginExperimental.name, (rel) => rel, () => null);

  // Bail if you don't have the login relationship
  React.useEffect(() => {
    if (!loginRelationship) {
      redirectToMaintenance();
    }
  }, [loginRelationship]);

  return (<Authentication url={loginRelationship.link('related').url()} />);
};
